/** 雪花 ID 统一转字符串，避免超过 MAX_SAFE_INTEGER 时 Number 精度丢失 */
export function normalizeSnowflakeId(
  id?: string | number | null,
): string | undefined {
  if (id == null || id === '') return undefined;
  return String(id);
}

export function splitHours(timeStart: string, timeEnd: string) {
  const hours: number[] = [];
  const [startHour] = timeStart.split(':').map(Number);
  const [endHour] = timeEnd.split(':').map(Number);

  for (let h = startHour; h < endHour; h++) {
    hours.push(h);
  }

  return hours;
}

export function downExcel(data: Blob, fileName: string) {
  // 创建下载链接
  const url = window.URL.createObjectURL(data);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${fileName}.xlsx`;

  // 触发下载
  document.body.appendChild(link);
  link.click();

  // 清理
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
